import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import styles from './TeamSearch.m.sass';
import Icon from '../../../components/Icon';
import cx from 'classnames';
var TeamSearch = observer(_class = /*#__PURE__*/function (_React$Component) {
  function TeamSearch() {
    _classCallCheck(this, TeamSearch);
    return _callSuper(this, TeamSearch, arguments);
  }
  _inherits(TeamSearch, _React$Component);
  return _createClass(TeamSearch, [{
    key: "render",
    value: function render() {
      var teamManagementStore = this.props.teamManagementStore;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.searchBar
      }, /*#__PURE__*/React.createElement("div", {
        className: cx(this.props.wideSearch && styles.wideSearch, styles.teamCentered)
      }, /*#__PURE__*/React.createElement(Icon, {
        className: styles.searchIcon,
        name: "search"
      }), /*#__PURE__*/React.createElement("input", {
        type: "search",
        className: styles.searchInput,
        value: teamManagementStore.searchText,
        onChange: function onChange(e) {
          return teamManagementStore.setSearchText(e.target.value);
        },
        placeholder: "Search teams..."
      })));
    }
  }]);
}(React.Component)) || _class;
export { TeamSearch as default };
//# sourceMappingURL=index.js.map
